export const NumberInputStyles = {
  field:
    'box-border border text-16px border-gray60 rounded w-full py-2 px-3 text-black leading-tight focus:border-blue100 focus:outline-2 focus:outline-blue100',
  error: `border-red200`,
}
